import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
interface CTAButtonProps {
  href: string;
  children: React.ReactNode;
  /** Opens in a new tab (used for the external checkout link). */
  external?: boolean;
  className?: string;
}
export function CTAButton({
  href,
  children,
  external = false,
  className = ''
}: CTAButtonProps) {
  return <a href={href} {...external ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {}} className={`group inline-flex w-full max-w-xl items-center justify-center gap-2 rounded-lg border-b-4 border-[#B23A00] bg-[#F26A1B] px-5 py-3.5 text-center font-display text-xl font-extrabold uppercase tracking-wide text-white shadow-lg transition-[transform,background-color] duration-150 ease-soft hover:bg-[#FF7A2B] active:translate-y-[2px] sm:text-2xl ${className}`} data-id="element-29" data-mp="2fya7vibp9b8e">
      <span data-id="element-30" data-mp="3cqdnu4oyjqw0">{children}</span>
      <ChevronRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-soft group-hover:translate-x-1" aria-hidden="true" data-id="element-31" data-mp="3cnhqahh0v483" />
    </a>;
}